import moment from 'moment';
import React, { Component } from 'react'
import { Dimmer, Header, Icon, Loader, Segment, Table } from 'semantic-ui-react';
import { getFailedCommissionPayments, updateExistingCommissionPayment } from '../../services/payment';
import { loadStripe } from '@stripe/stripe-js';
import PaymentClearModal from '../../components/PaymentClearModal/PaymentClearModal';
import { getPaymentMethods } from '../../services/Seller';
import './CommissionPaymentsContainer.less';
import Config from 'Config'
import { Elements, ElementsConsumer } from '@stripe/react-stripe-js';

class CommissionPaymentsContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pendingPayments: [],
            paymentMethods: [],
            selectedPaymentMethod: {},
            cardFormVisibility: true,
            loading: false,
            isModalOpen: false,
            card: undefined,
            error: '',
            failedPayments: [],
            isDefaultCard: true
        };
    }

    showLoader = () => {
        window.scrollTo({
            top: 0,
            behavior: 'auto'
        });
        document.body.style.overflowY = 'hidden'
        this.setState({ loading: true });
    }

    hideLoader = () => {
        document.body.style.overflowY = 'unset'
        this.setState({ loading: false });
    }

    componentDidMount() {
        loadStripe(Config.stripe.key).then(res => this.setState({ stripe: res }));
        this.showLoader();
        getFailedCommissionPayments().then(({ data }) => {
            this.setState({ pendingPayments: data })
            this.hideLoader();
        })
        getPaymentMethods().then(res => {
            if (res.data) {
                this.setState({
                    paymentMethods: res.data,
                    selectedPaymentMethod: res.data[0],
                    cardFormVisibility: false
                })
            }
            else {
                this.setState({ paymentMethods: [] })
            }
        })
    }

    onCardFormToggle = (e, value) => {
        e.preventDefault();
        this.setState({
            error: '',
            cardFormVisibility: value
        })
    }

    clearPayments = async (e) => {
        e.preventDefault();
        await this.processSecurePayments(this.state.pendingPayments.filter(fp => fp.paymentStatus == 'Action Required'))
        const failedPayments = this.state.pendingPayments.filter(fp => fp.paymentStatus == 'Failed');
        if (failedPayments.length) {
            this.setState({
                isModalOpen: true,
                failedPayments,
            })
        }
    }

    processSecurePayments = async (payments) => {
        this.showLoader();
        for await (const payment of payments) {
            try {
                const paymentConfirmation = await this.state.stripe.confirmCardPayment(payment.paymentIntent.client_secret, {
                    payment_method: payment.stripePaymentMethodID
                });
                if (!paymentConfirmation.error) {
                    await updateExistingCommissionPayment({
                        paymentIntentID: paymentConfirmation.paymentIntent.id,
                        scPaymentID: payment.scPaymentID
                    });
                }
            } catch (err) {
                console.log(err)
            }
        }
        if (payments.length) await this.resetState();
        this.hideLoader();
    }

    resetState = async () => {
        this.resetFailedPayments();
        this.setState({
            isModalOpen: false
        })
    }

    resetFailedPayments = async () => {
        const { data } = await getFailedCommissionPayments();
        this.setState({
            pendingPayments: data,
            failedPayment: data.filter(fp => fp.paymentStatus == 'Failed'),
        })
    }

    processFailedPayments = async () => {
        const { selectedPaymentMethod, card, cardFormVisibility, stripe, failedPayments } = this.state;
        let paymentMethod = selectedPaymentMethod;
        if (cardFormVisibility) {
            if (!card) {
                this.setState({ error: 'Invalid card details.' })
                return;
            }
            // payment method creation
            const paymentMethodRes = await stripe.createPaymentMethod({
                type: 'card',
                card
            });
            if (paymentMethodRes.error) {
                this.setState({ error: paymentMethodRes.error.message })
                return;
            }
            paymentMethod = paymentMethodRes.paymentMethod;
        }
        let paymentError;
        for await (const failedPayment of failedPayments) {
            try {
                this.showLoader();
                const paymentConfirmation = await stripe.confirmCardPayment(failedPayment.paymentIntent.client_secret, {
                    payment_method: paymentMethod.id,
                    setup_future_usage: 'off_session'
                });

                if (paymentConfirmation.error) {
                    paymentError = paymentConfirmation.error.message;
                    break;
                } else {
                    await updateExistingCommissionPayment({
                        paymentIntentID: paymentConfirmation.paymentIntent.id,
                        scPaymentID: failedPayment.scPaymentID,
                        isDefaultPaymentMethod: this.state.isDefaultCard
                    });
                }
            } catch (err) {
                console.log(err);
                paymentError = err;
                break;
            } finally {
                this.hideLoader();
            }
        }
        if (!paymentError) {
            await this.resetState();
        }
        else {
            this.resetFailedPayments();
            this.setState({ error: paymentError })
        }
    }

    render() {
        const { stripe, pendingPayments, error, paymentMethods, cardFormVisibility, loading, isModalOpen, selectedPaymentMethod, failedPayments } = this.state;
        return <>
            <Segment.Group>
                <Segment size="massive" className="no-radius">
                    <Header as="h1">
                        <Header.Content>
                            <Icon name='dollar sign'/>
                        Pending Commisson Payments
                    </Header.Content>
                    </Header>
                </Segment>
            </Segment.Group>
            <div className='pending-payment-container'>
                {stripe ? <Elements stripe={stripe}>
                    <ElementsConsumer>
                        {({ stripe, elements }) => <>
                            {loading ? <Dimmer className='pending-payment-loader-dimmer' active>
                                <Loader indeterminate size='massive' />
                            </Dimmer> : ''}

                            {pendingPayments && pendingPayments.length ? <>
                                <div>
                                    <div className='pending-payment-table-name'>Commission Payments</div>
                                    <button onClick={this.clearPayments} className='pending-payment-table-btn'>Clear Commission Payments</button>
                                    <div className='pending-payment-count'>Total: ${pendingPayments.map(fp => fp.amount).reduce((a, b) => Number(a) + Number(b), 0).toFixed(2)}</div>
                                </div>
                                <div className='pending-payment-table'>
                                    <Table size='large'>
                                        {window.innerWidth >= 768 ? <Table.Header>
                                            <Table.Row>
                                                <Table.HeaderCell>Category</Table.HeaderCell>
                                                <Table.HeaderCell>Service</Table.HeaderCell>
                                                <Table.HeaderCell>Bid Amount</Table.HeaderCell>
                                                <Table.HeaderCell>Commission</Table.HeaderCell>
                                                <Table.HeaderCell>Referral Fee</Table.HeaderCell>
                                                <Table.HeaderCell>Accepted On</Table.HeaderCell>
                                                <Table.HeaderCell>Amount</Table.HeaderCell>
                                            </Table.Row>
                                        </Table.Header> : ''}

                                        <Table.Body>
                                            {window.innerWidth >= 768 ? pendingPayments.map(c => <Table.Row>
                                                <Table.Cell>{c.categoryName}</Table.Cell>
                                                <Table.Cell>{c.serviceName}</Table.Cell>
                                                <Table.Cell>$ {c.bidAmount}</Table.Cell>
                                                <Table.Cell>{c.commission || c.defaultCommission ? `${c.commission || c.defaultCommission} %` : '-'}</Table.Cell>
                                                <Table.Cell>{c.referralFee || c.defaultReferralFee ? `$ ${c.referralFee || c.defaultReferralFee}` : '-'}</Table.Cell>
                                                <Table.Cell>{moment(c.acceptedOn).format('LLL')}</Table.Cell>
                                                <Table.Cell>$ {Number(c.amount)}</Table.Cell>
                                            </Table.Row>) : pendingPayments.map(c => <Table.Row>
                                                <Table.Cell>Category: {c.categoryName}</Table.Cell>
                                                <Table.Cell>Service: {c.serviceName}</Table.Cell>
                                                <Table.Cell>Bid Amount: $ {c.bidAmount}</Table.Cell>
                                                <Table.Cell>Commission:  {c.commission || c.defaultCommission ? `${c.commission || c.defaultCommission} %` : '-'}</Table.Cell>
                                                <Table.Cell>Referral Fee: {c.referralFee || c.defaultReferralFee ? `$ ${c.referralFee || c.defaultReferralFee}` : '-'}</Table.Cell>
                                                <Table.Cell>Accepted On: {moment(c.acceptedOn).format('LLL')}</Table.Cell>
                                                <Table.Cell>Amount: $ {Number(c.amount)}</Table.Cell>
                                            </Table.Row>)}
                                        </Table.Body>
                                    </Table>
                                </div></> : <div className='pending-payment-no-result'>No pending commission payments found</div>}

                            <PaymentClearModal
                                open={isModalOpen}
                                onClose={() => this.setState({ isModalOpen: false, error: '' })}
                                processFailedPayments={this.processFailedPayments}
                                stripe={stripe}
                                elements={elements}
                                onCardFormToggle={this.onCardFormToggle}
                                paymentMethods={paymentMethods}
                                setSelectedPaymentMethod={selectedPaymentMethod => this.setState({ selectedPaymentMethod })}
                                error={error}
                                isCardFormVisible={cardFormVisibility}
                                selectedPaymentMethod={selectedPaymentMethod}
                                commissionPaymentsDetail={{
                                    totalAmount: failedPayments.map(fp => fp.amount).reduce((a, b) => Number(a) + Number(b), 0),
                                    count: failedPayments.length
                                }}
                                setCard={card => this.setState({ card })}
                                isDefaultCard={this.state.isDefaultCard}
                                setIsDefaultCard={(value) => this.setState({isDefaultCard: value}) }
                            />
                        </>
                        }
                    </ElementsConsumer>
                </Elements> : ''
                }
            </div></>
    }
}

export default CommissionPaymentsContainer;